import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { environment } from '../environment/production';
import Select from 'react-select'

function UserPersonalDetails() {
  const [minFromDate,setMinFromDate]=useState(new Date())
  const [maxFromDate,setMaxFromDate]=useState(new Date())
  const [minToDate,setMinToDate]=useState(new Date())
  const [maxToDate,setMaxToDate]=useState(new Date())
  const [fileData,setFileData]=useState({
    fileName: null,
    base64URL: ''
  })
  
  const getBase64 = (file) => {
    setFileData({...fileData,fileName:file})
    return new Promise(resolve => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        
        baseURL = reader.result;
        
        setFileData({...fileData,base64URL:baseURL})
        let arr=file.name.split(".")
        
        if(arr[1]=="jpg" || arr[1]=="jpeg"){
          axios.post(environment.apiUrl+"/Personal/DocUpload",JSON.stringify({user_id:sessionStorage.getItem("user_id"),image:baseURL}),{headers:(options.headers)})
          .then((resp)=>{
            if(resp['data']['status']==1){
              alert(resp['data']['msg'])
            }else{
              alert(resp['data']['msg'])
            }
          })
        }else{
          alert("Only Jpg or Jpeg is allowed")
        }
        
        resolve(baseURL);
      };
      
    });
  };

  const handleFileInputChange = (e) => {
    
    let { file } = fileData;

    file = e.target.files[0];

    getBase64(file)
      .then(result => {
        file["base64"] = result;
        console.log("File Is", file);
        setFileData({...fileData,
          base64URL: result,
          
        });
      })
      .catch(err => {
        console.log(err);
      });
      setFileData({
        ...fileData,file: e.target.files[0]
      })
      handlePicUpload(e)
  };

  const selectRef = useRef("");
  let i = 0;
  const [picUpload,setPicUpload]=useState({
    image:'',
    imagePath:''
  })
  const [cityDetails, setCityDetails] = useState([])
  const [stateDetails, setStateDetails] = useState([])
  const [locationPreferenceDetails, setLocationPreferenceDetails] = useState([])
  const [checkboxValue, setCheckboxValue] = useState({
    title: '',
    category: '',
    post_applied: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
  })
  
  const [apiCall, setApiCall] = useState(0)
  const [postDetails, setPostDetails] = useState([])
  const [personalDetails, setPersonalDetails] = useState({ data: '' })
  const getPostDetails = () => {
    axios.post(environment.apiUrl + `/Personal/getPostDetails`, JSON.stringify({ user_id: parseInt(sessionStorage.getItem('user_id')) }), ({ headers: (options.headers) }))
      .then((response) => {

        if (response['data']['status'] == 1) {
          // const options = response['data']['data'].map(d => ({
          //   "value" : d.name_of_post,
          //   "label" : d.name_of_post
          // }))
          // this.setState({selectOptions: options})
          setPostDetails(response['data']['data'])
          //setPostDetails(options)
        }

      })
  }
  const getPersonalDetails = () => {
    axios.post(environment.apiUrl + `/Personal/getPersonalDetails`, JSON.stringify({ user_id: parseInt(sessionStorage.getItem('user_id')) }), ({ headers: (options.headers) }))
      .then((response) => {

        if (response['data']['status'] == 1) {
          console.log(response['data']['data'])
          setPersonalDetails({ data: response['data']['data'] })
          setPicUpload({...picUpload,imagePath:response['data']['data']['photo_path']})
          setCheckboxValue({...checkboxValue,
            title: response['data']['data']['title'],
            category: response['data']['data']['category'],
            post_applied: response['data']['data']['post_applied'],
            location_preference1: response['data']['data']['location_preference1'],
            location_preference2: response['data']['data']['location_preference2'],
            location_preference3: response['data']['data']['location_preference3'],
            present_state: response['data']['data']['present_state'],
            present_district: response['data']['data']['present_district'],
            present_pincode: response['data']['data']['present_pincode'],
            permanent_state: response['data']['data']['permanent_state'],
            permanent_district: response['data']['data']['permanent_district'],
            permanent_pincode: response['data']['data']['permanent_pincode'],
            office_state: response['data']['data']['office_state'],
            office_district: response['data']['data']['office_district'],
            office_pincode: response['data']['data']['office_pincode']
          })
        }

      })
      return picUpload.imagePath
  }
  useEffect(() => {
    if (apiCall == 0) {
      getPostDetails()
      getPersonalDetails()
      getStateDetails()
      getCityDetails()
      getLocationPreference()
    }
    setApiCall(1)
  }, [apiCall])
  let checked = personalDetails.data.permanent_address !== '' ? true : false;

  const [checkbox, setCheckbox] = useState(false);
  const [formdata, setFormData] = useState({
    user_id: null,
    post_applied: '',
    title: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_title: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    date_of_birth: '',
    mobile_no: '',
    email_id: '',
    category: '',
    designation: '',
    present_address: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_address: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_address: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    date_of_entry_into_govt_service: '',
    date_of_retirement_from_govt_service: '',
    current_designation: '',
    current_pay_matrix: '',
    no_of_yrs_current_pay_matrix: '',
    state_whether_applicable_for_post_applying:''
  });
  
  const [errormsg, setErrorMsg] = useState({
    post_applied: '',
    title: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_title: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    date_of_birth: '',
    mobile_no: '',
    email_id: '',
    category: '',
    designation: '',
    present_address: '',
    present_state: '',
    present_district: '',
    present_pincode: '',
    permanent_address: '',
    permanent_state: '',
    permanent_district: '',
    permanent_pincode: '',
    office_address: '',
    office_state: '',
    office_district: '',
    office_pincode: '',
    location_preference1: '',
    location_preference2: '',
    location_preference3: '',
    date_of_entry_into_govt_service: '',
    date_of_retirement_from_govt_service: '',
    current_designation: '',
    current_pay_matrix: '',
    no_of_yrs_current_pay_matrix: ''
  });

  const [permanentAddress, setPermanentAddress] = useState('')
  const [permanentState, setPermanentState] = useState('')
  const [permanentDistrict, setPermanentDistrict] = useState('')
  const [permanentPincode, setPermanentPincode] = useState('')

  const [formerror, setFormError] = useState({
    post_applied: ''
  })
  const options = {
    data: {
      formdata
    },
    headers: {
      'Authorization': sessionStorage.getItem("access_token")
    }
  }
  /*
  function getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}
*/
  const handlePicUpload=(e)=>{
     e.preventDefault();
     
     //console.log(atob(new Blob([e.target.files[0]], {type:"text/plain"})))
     //getBase64(e.target.files[0], (result) => {
      
      axios.post(environment.apiUrl+"/Personal/DocUpload",JSON.stringify({user_id:sessionStorage.getItem("user_id"),image:fileData.base64URL}),{headers:(options.headers)})
    .then((resp)=>{
      if(resp['data']['status']==1){
        alert(resp['data']['msg'])
      }else{
        alert(resp['data']['msg'])
      }
    })
     
    
  }
  
  function fromDateChange(event: any) {
 
    setMaxFromDate(document.getElementById("date_of_entry_into_govt_service").value)
  }
  
  
  const userRegistrationAPI = (e) => {
    // e.preventDefault();
    axios.post(environment.apiUrl + `/Personal/CreateUpdate`, JSON.stringify(options.data.formdata), ({ headers: (options.headers) }))
      .then((response) => {
        if (response['data']['status'] == 1) {
          $('.wizard-btn').attr('disabled', false)

          alert(response['data']['msg'])
        } else {
          alert(response['data']['msg'])
        }

      })

  }


  function handleCheckBoxAddress(e) {
   
    if (e.target.checked == true) {
      // $('#permanent_address').val(permanentAddress)
      // $('#permanent_district').val(permanentDistrict)
      // $('#permanent_state').val(permanentState)
      // $('#permanent_pincode').val(permanentPincode)
      document.getElementById('permanent_address').value=document.getElementById('present_address').value;
      document.getElementById('permanent_district').value=document.getElementById('present_district').value;
      document.getElementById('permanent_state').value=document.getElementById('present_state').value;
      document.getElementById('permanent_pincode').value=document.getElementById('present_pin_code').value;
    } else {
      // $('#permanent_address').val('')
      // $('#permanent_district').val('')
      // $('#permanent_state').val('')
      // $('#permanent_pincode').val('')
      document.getElementById('permanent_address').value='';
      document.getElementById('permanent_district').value='';
      document.getElementById('permanent_state').value='';
      document.getElementById('permanent_pincode').value='';
    }
  }

  const handleFormValidation = () => {
    let image=getPersonalDetails()!==''?false:true
    if (formdata.email_id === '') {
      alert("Email id is required")
    } else if (formdata.post_applied === '') {
      alert("Post applied is required")
    } else if (formdata.title === '') {
      alert("Title is required")
    } else if (formdata.first_name === '') {
      alert("First name is required")
    } else if (formdata.last_name === '') {
      alert("Last name is required")
    } else if (formdata.date_of_birth === '') {
      alert("Date of birth is required")
    } else if (formdata.mobile_no === '') {
      alert("Mobile number is required")
    } else if (formdata.mobile_no.length !== 10) {
      alert("Mobile number should be 10 digits")
    } else if (formdata.category === '') {
      alert("Category is required")
    } else if (formdata.present_address === '') {
      alert("Present address is required")
    } else if (formdata.present_state === '') {
      alert("Present state is required")
    } else if (formdata.present_district === '') {
      alert("Present district is required")
    } else if (formdata.present_pincode === '') {
      alert("Present pincode is required")
    } else if (formdata.present_pincode.length !== 6) {
      alert("Present pincode should be 6 digits")
    } else if (formdata.permanent_address === '') {
      alert("Permanent address is required")
    } else if (formdata.permanent_state === '') {
      alert("Permanent state is required")
    } else if (formdata.permanent_district === '') {
      alert("Permanent district is required")
    } else if (formdata.permanent_pincode === '') {
      alert("Permanent pincode is required")
    } else if (formdata.permanent_pincode.length !== 6) {
      alert("Permanent pincode should be 6 digits")
    } else if (formdata.location_preference1 === '') {
      alert("Location preference 1 is required")
    } else if (formdata.location_preference2 === '') {
      alert("Location preference 2 is required")
    } else if (formdata.location_preference3 === '') {
      alert("Location preference 3 is required")
    } else if (formdata.date_of_entry_into_govt_service === '') {
      alert("Date of Entry into Government Service is Required")
    } else if (formdata.date_of_retirement_from_govt_service === '') {
      alert("Date of Retirement from Government Service is Required")
    } else if (formdata.current_designation === '') {
      alert("Current designation is Required")
    } else if (formdata.current_pay_matrix === '') {
      alert("Current pay mattrix is Required")
    } else if (formdata.no_of_yrs_current_pay_matrix === '') {
      alert("No. of years in current pay mattrix is Required")
    }else if(formdata.state_whether_applicable_for_post_applying===''){
      alert("State whether applicable for post applying field is required")
    }else if((image)){
      if(document.getElementById("image").value==''){
        alert("Image is required")
      }else{
        userRegistrationAPI();
      }
      
    } else {
      userRegistrationAPI();
    }
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    //console.log(e.target.appl_recvd_d.value);
    formdata.user_id = parseInt(sessionStorage.getItem("user_id"));
    formdata.post_applied = e.target.post_applied.value;
    formdata.title = e.target.title.value;
    formdata.first_name = e.target.first_name.value;
    formdata.middle_name = e.target.middle_name.value;
    formdata.last_name = e.target.last_name.value;
    formdata.father_title = "";
    formdata.father_first_name = "";
    formdata.father_middle_name = "";
    formdata.father_last_name = "";
    formdata.date_of_birth = e.target.date_of_birth.value;
    formdata.mobile_no = e.target.mobile_no.value;
    formdata.email_id = e.target.email_id.value;
    formdata.category = e.target.category.value;
    formdata.designation = "";
    formdata.present_address = e.target.present_address.value;
    formdata.present_state = e.target.present_state.value;
    formdata.present_district = e.target.present_district.value;
    formdata.present_pincode = e.target.present_pincode.value;
    formdata.permanent_address = e.target.permanent_address.value;
    formdata.permanent_state = e.target.permanent_state.value;
    formdata.permanent_district = e.target.permanent_district.value;
    formdata.permanent_pincode = e.target.permanent_pincode.value;
    formdata.office_address = e.target.office_address.value;
    formdata.office_state = e.target.office_state.value;
    formdata.office_district = e.target.office_district.value;
    formdata.office_pincode = e.target.office_pincode.value;
    formdata.location_preference1 = e.target.location_preference1.value;
    formdata.location_preference2 = e.target.location_preference2.value;
    formdata.location_preference3 = e.target.location_preference3.value;
    formdata.date_of_entry_into_govt_service = e.target.date_of_entry_into_govt_service.value;
    formdata.date_of_retirement_from_govt_service = e.target.date_of_retirement_from_govt_service.value;
    formdata.current_designation = e.target.current_designation.value;
    formdata.current_pay_matrix = e.target.current_pay_matrix.value;
    formdata.no_of_yrs_current_pay_matrix = e.target.no_of_yrs_current_pay_matrix.value
    formdata.state_whether_applicable_for_post_applying = e.target.state_whether_applicable_for_post_applying.value
    setFormData(...[formdata]);
    
    handleFormValidation()
  }
  function getCityDetailsByStateId(value) {
    
    axios.post(environment.apiUrl + "/Master/getCityByStateId",JSON.stringify({state_id:value}))
      .then((response) => {
    
        if (response.data.status == 1) {
          setCityDetails(response.data.cityData)
        }
      })
  }
  function getCityDetails(value) {
    
    axios.post(environment.apiUrl + "/Master/getCityList")
      .then((response) => {
    
        if (response.data.status == 1) {
          setCityDetails(response.data.cityData)
        }
      })
  }
  function getStateDetails() {
    axios.post(environment.apiUrl + "/Master/getStateList")
      .then((response) => {

        if (response.data.status == 1) {
          setStateDetails(response.data.stateData)
        }
      })
  }
  function getLocationPreference() {
    axios.post(environment.apiUrl + "/Master/getLocationPreference")
      .then((response) => {

        if (response.data.status == 1) {
          setLocationPreferenceDetails(response.data.location_preferenceData)
        }
      })
  }
  return (

    <>

      <div className="container-fluid page-body-wrapper">
        <div className="col-sm-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Personal Details</h4>
              <p className="card-description"> Kindly save the personal details before proceeding </p>
              <form className="forms-sample" onSubmit={(event) => handleFormSubmit(event)}>

                <div className="row">
                  <div className="form-group col-sm-2">

                    <label>Post applied for <span className="text-danger">*</span></label>
                    {/* <Select value={{value:checkboxValue.post_applied,label:checkboxValue.post_applied}} name="post_applied" id="exampleInputName1" ref={selectRef} options={postDetails} onChange={onChangeSelect} /> */}

                    <select className="form-select" value={checkboxValue.post_applied || ''} name="post_applied" onChange={(event) => setCheckboxValue({ ...checkboxValue, post_applied: event.target.value })} id="post_applied">
                      <option value="">Select Post Applied for</option>
                      {

                        (postDetails).map((value) => (
                          <option key={value.name_of_post} value={value.name_of_post}>{(value.name_of_post)}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-2">
                    <label>Preference 1 <span className="text-danger">*</span></label>
                    <select className="form-select" value={checkboxValue.location_preference1 || ''} name="location_preference1" onChange={(event) => setCheckboxValue({ ...checkboxValue, location_preference1: event.target.value })} id="location_preference1">
                      <option value="">Select location applying for</option>
                      {

                        locationPreferenceDetails.map((key, value) => (

                        <option key={key.location_preference} value={key.location_preference}>{key.location_preference}</option>
                      ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-2">
                    <label>Preference 2 <span className="text-danger">*</span></label>
                    <select className="form-select" value={checkboxValue.location_preference2 || ''} name="location_preference2" id="location_preference2" onChange={(event) => setCheckboxValue({ ...checkboxValue, location_preference2: event.target.value })}>
                    <option value="">Select location applying for</option>
                    {

                      locationPreferenceDetails.map((key, value) => (

                      <option key={key.location_preference} value={key.location_preference}>{key.location_preference}</option>
                      ))
                    }
                    </select>
                  </div>
                  <div className="form-group col-sm-2">
                    <label>Preference 3 <span className="text-danger">*</span></label>
                    <select className="form-select" value={checkboxValue.location_preference3 || ''} name="location_preference3" id="location_preference3" onChange={(event) => setCheckboxValue({ ...checkboxValue, location_preference3: event.target.value })}>
                    <option value="">Select location applying for</option>
                    {

                      locationPreferenceDetails.map((key, value) => (

                      <option key={key.location_preference} value={key.location_preference}>{key.location_preference}</option>
                      ))
                    }
                    </select>
                  </div>
                  <div className="form-group col-sm-4">
                    <label>Upload Photo <span className="text-danger">*</span></label><span>{picUpload.imagePath}</span>
                    <input type="file" className="form-control" onChange={(e)=>getBase64(e.target.files[0])} name="image" id="image" />
                    
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-sm-3">
                    <label>Title <span className="text-danger">*</span></label>
                    <select className="form-select" value={checkboxValue.title || ''} name="title" id="title" onChange={(event) => setCheckboxValue({ ...checkboxValue, title: event.target.value })}>
                      <option value="">Select Title</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                    </select>

                  </div>

                  <div className="form-group col-sm-3">
                    <label>First Name <span className="text-danger">*</span></label>
                    <input type="text" name="first_name" readOnly={true} defaultValue={sessionStorage.getItem("first_name") || ""} className="form-control" id="exampleInputName1" placeholder="First Name" />
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Middle Name</label>
                    <input type="text" name="middle_name" readOnly={true} defaultValue={(sessionStorage.getItem("middle_name")) || ""} className="form-control" id="exampleInputName1" placeholder="Middle Name" />
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Last Name <span className="text-danger">*</span></label>
                    <input type="text" name="last_name" readOnly={true} defaultValue={(sessionStorage.getItem("last_name")) || ""} className="form-control" id="exampleInputName1" placeholder="Last Name" />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-sm-6">
                    <label>Email address <span className="text-danger">*</span></label>
                    <input type="email" name="email_id" readOnly={true} defaultValue={(sessionStorage.getItem("email_id")) || ""} className="form-control" id="exampleInputEmail3" placeholder="Email" />
                  </div>
                  <div className="form-group  col-sm-6">
                    <label>Contact Number <span className="text-danger">*</span></label>
                    <input type="number" name="mobile_no" readOnly={true} defaultValue={(sessionStorage.getItem("mobile_no")) || ""} className="form-control" id="exampleInputPassword4" placeholder="Contact Number" />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-sm-3" hidden={true}>
                    <label>Category <span className="text-danger">*</span></label>
                    <select className="form-select" value={checkboxValue.category || ''} name="category" id="category" onChange={(event) => setCheckboxValue({ ...checkboxValue, category: event.target.value })}>
                      {/* <option value="">Select Category</option> */}
                      <option value="Un-Reserved">Un-Reserved</option>
                      <option value="EWS">EWS</option>
                      <option value="SC">SC</option>
                      <option value="ST">ST</option>
                      <option value="OBC">OBC</option>
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>DOB <span className="text-danger">*</span></label>
                    <input type="date" defaultValue={personalDetails.data.date_of_birth || ''} name="date_of_birth" className="form-control" id="dob" />
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Date of entry into government service <span className="text-danger">*</span></label>
                    <input type="date" name="date_of_entry_into_govt_service" min={minFromDate} max={minToDate} onChange={(e)=>fromDateChange(e)} defaultValue={personalDetails.data.date_of_entry_into_govt_service || ''} className="form-control" id="date_of_entry_into_govt_service" />
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Date of retirement as per Parent cadre rules <span className="text-danger">*</span></label>
                    <input type="date" name="date_of_retirement_from_govt_service" min={maxFromDate} max={maxToDate} defaultValue={personalDetails.data.date_of_retirement_from_govt_service || ''} className="form-control" id="date_of_retirement_from_govt_service" />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-sm-4">
                    <label>Current Designation <span className="text-danger">*</span></label>
                    <input type="text" defaultValue={personalDetails.data.current_designation || ''} className="form-control" name="current_designation" id="current_designation" />
                  </div>
                  <div className="form-group col-sm-4">
                    <label>Current Pay Matrix <span className="text-danger">*</span></label>
                    <input type="text" defaultValue={personalDetails.data.current_pay_matrix || ''} className="form-control" name="current_pay_matrix" id="current_pay_matrix" />
                  </div>
                  <div className="form-group col-sm-4">
                    <label>Number of years in current pay matrix <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" defaultValue={personalDetails.data.no_of_yrs_current_pay_matrix || ''} name="no_of_yrs_current_pay_matrix" id="no_of_yrs_current_pay_matrix" />
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-sm-12">
                    <label>Please state clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post <span className="text-danger">*</span></label>
                    <textarea className="form-control" defaultValue={personalDetails.data.state_whether_applicable_for_post_applying || ''}  name="state_whether_applicable_for_post_applying" id="state_whether_applicable_for_post_applying" rows="4" placeholder="State clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post"></textarea>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-sm-4">
                    <label style={{textAlign:'left'}}>Please state clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post <span className="text-danger">*</span></label>
                    <select className="form-select" onChange={(event)=>{
                      setPersonalDetails({...personalDetails,data:({state_whether_applicable_for_post_applying:event.target.value})})

                    }} value={personalDetails.data.state_whether_applicable_for_post_applying || ''}  name="state_whether_applicable_for_post_applying" id="state_whether_applicable_for_post_applying" rows="4" placeholder="State clearly whether in the light of entries made by you above, you meet the requisite essential qualification and work experience for the post">
                      <option value="">Please select Yes or No</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <br />

                <div className="row">
                  <div className="form-group col-sm-3">
                    <label>Present Address <span className="text-danger">*</span></label>
                    <textarea name="present_address" defaultValue={personalDetails.data.present_address || ''} onChange={(e) => {
                      setPermanentAddress(e.target.value)
                    }} className="form-control" id="present_address" rows="4" placeholder="Address"></textarea>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>District <span className="text-danger">*</span></label>
                    <select name="present_district" value={checkboxValue.present_district || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, present_district: event.target.value })


                    }} className="form-select" id="present_district">
                      <option value="">Select District</option>
                      {

                        cityDetails.map((key, value) => (

                          <option key={value} value={key.city}>{key.city}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>State <span className="text-danger">*</span></label>
                    <select name="present_state" id="present_state" value={checkboxValue.present_state || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, present_state: event.target.value })
                      getCityDetailsByStateId(event.target.value)
                    }} className="form-select">
                      <option value="">Select State</option>
                      {

                        stateDetails.map((key, value) => (

                          <option key={value} value={key.id}>{key.name}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Pin Code <span className="text-danger">*</span></label>
                    <input name="present_pincode" defaultValue={personalDetails.data.present_pincode
                      || ''} onChange={(e) => {

                        setPermanentPincode(e.target.value)


                      }} type="text" className="form-control" id="present_pin_code" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-1">
                    <input name="check_box_address" defaultChecked={false} onChange={(e) => handleCheckBoxAddress(e)} type="checkbox" id="check_box_address" />
                  </div>
                  <div className="col-sm-8" style={{textAlign: 'left'}}>
                    {/* style={{marginLeft: '-18%'}} */}
                    <label>Check this if present address is same as permanent address</label>

                  </div>
                </div><br />
                <div className="row">
                  <div className="form-group col-sm-3">
                    <label>Permanent Address <span className="text-danger">*</span></label>
                    <textarea name="permanent_address" defaultValue={personalDetails.data.permanent_address
                      || ''} id="permanent_address" className="form-control" rows="4" placeholder="Address"></textarea>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>District <span className="text-danger">*</span></label>
                    <select name="permanent_district" value={checkboxValue.permanent_district || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, permanent_district: event.target.value })


                    }} id="permanent_district" className="form-select">
                      <option value="">Select District</option>
                      {

                        cityDetails.map((key, value) => (

                          <option key={value} value={key.city}>{key.city}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>State <span className="text-danger">*</span></label>
                    <select name="permanent_state" value={checkboxValue.permanent_state || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, permanent_state: event.target.value })

                      getCityDetails(event.target.value)
                    }} id="permanent_state" className="form-select">
                      <option value="">Select State</option>
                      {

                        stateDetails.map((key, value) => (

                          <option key={value} value={key.id}>{key.name}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Pin Code <span className="text-danger">*</span></label>
                    <input name="permanent_pincode" defaultValue={personalDetails.data.permanent_pincode || ''} id="permanent_pincode" type="text" className="form-control" />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-sm-3">
                    <label>Office Address</label>
                    <textarea name="office_address" defaultValue={personalDetails.data.office_address || ''} className="form-control" id="exampleTextarea1" rows="4" placeholder="Address"></textarea>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>District</label>
                    <select name="office_district" value={checkboxValue.office_district || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, office_district: event.target.value })


                    }} className="form-select">
                      <option value="">Select District</option>
                      {

                        cityDetails.map((key, value) => (

                          <option key={value} value={key.city}>{key.city}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>State</label>
                    <select name="office_state" value={checkboxValue.office_state || ''} onChange={(event) => {

                      setCheckboxValue({ ...checkboxValue, office_state: event.target.value })
                      getCityDetails(event.target.value)

                    }} className="form-select">
                      <option value="">Select State</option>
                      {

                        stateDetails.map((key, value) => (

                          <option key={value} value={key.id}>{key.name}</option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="form-group col-sm-3">
                    <label>Pin Code</label>
                    <input name="office_pincode" defaultValue={personalDetails.data.office_pincode || ''} type="text" className="form-control" id="present_pin_code" />
                  </div>
                </div>
                <button type="submit" style={{ width: '100px' }} className="btn btn-primary me-2">Save</button>

              </form>
            </div>
          </div>
        </div>
      </div>


    </>

  )
}

export default UserPersonalDetails